import pickBy from 'lodash/pickBy';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';

/**
 * Returns a new object with all undefined values removed.
 */
export function omitUndefined(obj) {
  return pickBy(obj, function (value) {
    return value !== undefined;
  });
}

/**
 * Returns a new object with shallow-camelized keys.
 *
 * @param {*} obj
 */
export function camelizeKeys(obj) {
  return mapKeys(obj, function (_, key) {
    return camelCase(key);
  });
}

/**
 * Returns a new object with shallow-camelized keys.
 *
 * @param {*} obj
 */
export function snakeizeKeys(obj) {
  return mapKeys(obj, function (_, key) {
    return snakeCase(key);
  });
}
//# sourceMappingURL=objectUtil.js.map
